import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from "react-router-dom";
import 'what-input';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './utils/DataPersister';
import './utils/DataFetcher';
import './utils/Localizator';
import './scss/index.scss';
import './User';
import './utils/Events2Use';

// Backbutton functionality
const history = require("history").createBrowserHistory();

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>
  , document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

if(['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) document.body.classList.add("is-ios");
